
import { component } from '@/helpers/vueTyped';
import WithFetch from '@/components/Helpers/WithFetch.vue';
import store from '@/store';
import { FeedItem, Feed } from '@/api/validators/feed';

interface FeedFetcherProps {
  type: 'article' | 'video' | 'score';
  itemsPerRequest?: number;
  autoUpdate?: boolean;
  optionalFeedArgs?: object;
}

interface ScopedSlots {
  default: {
    feed: FeedItem[],
    fetchMore?: () => void,
    isLoading?: true,
  };
}

export default component<FeedFetcherProps, {}, ScopedSlots>()({
  name: 'FeedFetcher',

  props: {
    type: {},
    itemsPerRequest: { default: 12 },
    autoUpdate: Boolean,
    optionalFeedArgs: {},
  },

  data() {
    return {
      feed: [] as FeedItem[],
      token: undefined as undefined | string,
      nextToken: [] as [string] | [],
      loadPromise: undefined as unknown as Promise<void>,
      loadPromiseResolver: undefined as unknown as (() => void),
      entityTagIds: store.state.navigationState.tournament ? [store.state.navigationState.tournament] : [],
    };
  },

  computed: {
    withFetchAutoUpdate(): false | { interval?: number, payload?: any[] } | undefined {
      return this.autoUpdate && {
        payload: [this.type, this.entityTagIds, this.itemsPerRequest, this.optionalFeedArgs],
        interval: 60000,
      };
    },
  },

  methods: {
    async fetch() {
      await this.loadPromise;

      this.token = this.nextToken[0];

      this.resetLoadPromise();
    },

    loadHandler(response: Feed, autoUpdate: boolean) {
      if (autoUpdate) {
        this.feedLoadedAutoUpdate(response);
      } else {
        this.feedLoaded(response);
      }

      this.loadPromiseResolver();
    },

    feedLoaded(response: Feed) {
      if (response.feed) {
        this.feed.push(...response.feed);
      }

      if (response.pagination?.continuationToken) {
        this.nextToken[0] = response.pagination.continuationToken;
      }
    },

    feedLoadedAutoUpdate(response: Feed) {
      if (!response.feed) {
        this.feed = [];
        return;
      }

      if (!response.pagination?.continuationToken) {
        this.feed = response.feed;
        return;
      }

      if (!this.nextToken[0]) {
        this.nextToken[0] = response.pagination.continuationToken;
        this.feed = response.feed;
        return;
      }

      const lastResponse = response.feed[response.feed.length - 1];
      const index = this.feed.findIndex((f) => f.feedId === lastResponse.feedId);

      if (index < 0) {
        this.feed = response.feed;
        return;
      }

      const feedClone = this.feed.slice();
      feedClone.splice(0, index + 1, ...response.feed);
      this.feed = feedClone;
    },

    resetLoadPromise() {
      this.loadPromise = new Promise((ok) => {
        this.loadPromiseResolver = ok;
      });
    },
  },

  created() {
    this.resetLoadPromise();
  },

  render() {
    return (
      <WithFetch
        apiCall='fetchFeed'
        fetchDelay={500}
        payload={[this.type, this.entityTagIds, this.itemsPerRequest, this.optionalFeedArgs, this.token]}
        returnIsLoading
        onLoad={this.loadHandler}
        autoUpdate={this.withFetchAutoUpdate}
        cacheRefreshOnUpdate
        scopedSlots={{
          loaded: ({ isLoading }) => (
            this.$scopedSlots.default({
              feed: this.feed,
              fetchMore: this.nextToken[0] !== this.token ? this.fetch : undefined,
              isLoading,
            })
          ),
        }}
      />
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-ce26d9cc/FeedFetcher.vue" });